import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from './locale/en-US.js'
import zhCN from './locale/zh-CN.js'
import jaJP from './locale/ja-JP.js'
Vue.use(VueI18n)
export const defaultLang = navigator.language
const localStorage = window.localStorage
const supportedLang = ['zh-CN', 'ja-JP', 'en-US']
// 语言以右上角选过的为准。旧的或是脏的值当没选过处理，否则整站只能走 fallback，看着像切换无效
let mLang = localStorage.getItem('mLang')
if (supportedLang.indexOf(mLang) < 0) {
  mLang = ''
}
// 调试模式只是把默认值改成日语，方便逐页核对日文文案，不是锁定日语；生产环境同样只在没选过时按域名给默认
if (!mLang) {
  if (process.env.NODE_ENV === 'development') {
    mLang = 'ja-JP'
  } else {
    const host = window.location.host
    if (host === 'cloud.reflexwireless.jp') {
      mLang = 'ja-JP'
    } else if (host === 'cloud.reflexwireless.com') {
      mLang = 'en-US'
    } else if (host.indexOf('localhost') >= 0 || host === 'cloud.breathmeters.cn') {
      mLang = 'zh-CN'
    } else {
      mLang = 'en-US'
    }
  }
}
const i18n = new VueI18n({
  locale: mLang, // 语言标识
  fallbackLocale: 'en-US',
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN,
    'ja-JP': jaJP
  }
})

export function getI18nLanguage () {
  return i18n.locale
}
export function setI18nLanguage (lang) {
  i18n.locale = lang
}
export function i18nRender (key, values) {
  return i18n.t(`${key}`, values)
}
export default i18n
